import { DateTimeFormatter } from "@js-joda/core";
import { createContext } from "react";

export interface DateTimeFormat {
  dateTimeFormatter: DateTimeFormatter;
  dateFormatter: DateTimeFormatter;
}

export const DateTimeFormatContext = createContext<DateTimeFormat>({
  dateTimeFormatter: DateTimeFormatter.ISO_LOCAL_DATE_TIME,
  dateFormatter: DateTimeFormatter.ISO_LOCAL_DATE,
});
